import { css } from 'linaria';
import { strictBreakpoints } from '../../../../../media';

export const serviceStyles = css`
	display: flex;
	flex-direction: column;
	overflow: hidden;
	text-decoration: none;
	color: #333333;
	background: #fff;
	border-radius: 8px;
	span {
		padding: 24px;
	}
	${strictBreakpoints.onlyMobile} {
		max-width: 204px;
		span {
			padding: 24px 16px;
		}
	}
`;
export const serviceTypographyStyles = css`
	padding: 24px !important;
`;
